import { LocalizationRes } from "@centricsoftware/design-system";
import { ILocaleProvider } from "designSystem/locale";
import { EXPRESSION_RUNTIME_ENUM_CONTINUOUS, EXPRESSION_RUNTIME_ENUM_ONETIME } from "./AttributeDefinitionStore";

export default class AttributeDefinitionLocale  {
	loc : ILocaleProvider;

	helperTextAttributeDefinitionHasInitialValue: string;
	helperTextExpressionRuntimeContinuous: string;
	helperTextExpressionRuntimeOneTime: string;
	labelConfigurableAttributeColumnWidth: string;
	labelCopyOptionsName: string;
	labelExpressionContinuous: string;
	labelExpressionOneTime: string;
	labelInitialValue: string;
	labelRESTNone: string;
	labelRESTRead: string;
	labelRESTWrite: string;
	labelRequired: string;
	labelUOM: string;
	labelUOMType: string;

	helperTextAttributeDefinitionHasInitialValueRes: LocalizationRes = { res: "AttributeDefinitionHelperTextInitialValue" };
	helperTextAttributeIdRes: LocalizationRes = { res: "AttributeDefinitionHelperTextAttributeId" };
	helperTextCopyOptionsNameRes: LocalizationRes = { res: "AttributeDefinitionHelperTextCopyOptionsName" };
	helperTextDisplayNameRes: LocalizationRes = { res: "AttributeDefinitionHelperTextDisplayName" };
	helperTextEvaluateOnClientRes: LocalizationRes = { res: "AttributeDefinitionHelperTextExpressionEvaluateOnClient" };
	helperTextExpressionRuntimeContinuousRes: LocalizationRes = { res: "AttributeDefinitionHelperTextExpressionRuntimeContinuous" };
	helperTextExpressionRuntimeOneTimeRes: LocalizationRes = { res: "AttributeDefinitionHelperTextExpressionRuntimeOneTime" };
	helperTextHiddenRes: LocalizationRes = { res: "AttributeDefinitionHelperTextHidden" };
	helperTextReadonlyRes: LocalizationRes = { res: "AttributeDefinitionHelperTextReadonly" };
	helperTextRequiredRes: LocalizationRes = { res: "AttributeDefinitionHelperTextRequired" };
	helperTextSubtypeConfigurationRes: LocalizationRes = { res: "AttributeDefinitionHelperTextSubtypeConfiguration" };
	helperTextValidationErrorMessageRes: LocalizationRes = { res: "AttributeDefinitionHelperTextValidationErrorMessage" };
	labelAllRes: LocalizationRes = { res: "All" };
	labelAutofillDependentEnum: LocalizationRes = { res: "AttributeDefinitionAutofillDependentEnum" };
	labelCloseRes: LocalizationRes = { res: "Close" };
	labelCopyCategoryRes: LocalizationRes = { res: "AttributeDefinitionCopyCategory" };
	labelCopyOptionsRes: LocalizationRes = { res: "AttributeDefinitionCopyOptions" };
	labelCopyOptionsNameNoteRes: LocalizationRes = { res: "AttributeDefinitionCopyOptionsNameNote" };
	labelDisableDragEditsRes: LocalizationRes = { res: "AttributeDefinitionDisableDragEdits" };
	labelEditEnumerationsRes: LocalizationRes = { res: "AttributeDefinitionEditEnumerations" };
	labelEnableCommentsRes: LocalizationRes = { res: "AttributeDefinitionEnableComments" };
	labelEnableExpressionRes: LocalizationRes = { res: "AttributeDefinitionEnableExpression" };
	labelEnabledRes: LocalizationRes = { res: "Enabled" };
	labelExpressionRes: LocalizationRes = { res: "AttributeDefinitionExpression" };
	labelExpressionEvaluateOnClientRes: LocalizationRes = { res: "AttributeDefinitionExpressionEvaluateOnClient" };
	labelExpressionRuntimeRes: LocalizationRes = { res: "AttributeDefinitionExpressionRuntime" };
	labelFormatRes: LocalizationRes = { res: "Format" };
	labelHiddenRes: LocalizationRes = { res: "AttributeDefinitionHidden" };
	labelInitialValueRes: LocalizationRes = { res: "AttributeDefinitionInitialValue" };
	labelLocaleNameRes: LocalizationRes = { res: "LocaleName" };
	labelNotesRes: LocalizationRes = { res: "AttributeDefinitionNotes" };
	labelRESTRes: LocalizationRes = { res: "AttributeDefinitionRESTAccess" };
	labelRESTNoneRes: LocalizationRes = { res: "AttributeDefinitionRESTAccessNone" };
	labelRESTReadRes: LocalizationRes = { res: "AttributeDefinitionRESTAccessRead" };
	labelRESTWriteRes: LocalizationRes = { res: "AttributeDefinitionRESTAccessWrite" };
	labelReadonlyRes: LocalizationRes = { res: "AttributeDefinitionReadonly" };
	labelReflectionAttributeIdRes: LocalizationRes = { res: "ReflectionAttributeId" };
	labelRequiredRes: LocalizationRes = { res: "AttributeDefinitionRequired" };
	labelSelectEnumerationRes: LocalizationRes = { res: "AttributeDefinitionEnumeration" };
	labelSubtypeConfigurationRes: LocalizationRes = { res: "AttributeDefinitionAllowSubtypeConfiguration" };
	labelTooltipRes: LocalizationRes = { res: "AttributeDefinitionTooltip" };
	labelUOMEnabledRes: LocalizationRes = { res: "AttributeDefinitionUOM" }; // "Unit of Measurement"
	labelValidationErrorMessageRes: LocalizationRes = { res: "ValidationErrorMessage" };
	labelValidationExpressionRes: LocalizationRes = { res: "ValidationExpression" };
	labelValueTypeRes: LocalizationRes = { res: "ValueType" };

	constructor(loc: ILocaleProvider) {
		this.loc = loc;

		this.helperTextAttributeDefinitionHasInitialValue = loc.resource("AttributeDefinitionHelperTextInitialValue");
		this.helperTextExpressionRuntimeContinuous = loc.resource("AttributeDefinitionHelperTextExpressionRuntimeContinuous");
		this.helperTextExpressionRuntimeOneTime = loc.resource("AttributeDefinitionHelperTextExpressionRuntimeOneTime");
		this.labelConfigurableAttributeColumnWidth = loc.attributeResource("ConfigurableAttribute", "ColumnWidth");
		this.labelCopyOptionsName = loc.enumResource("AttributeDefinitionCopyOptionsName");
		this.labelExpressionContinuous = loc.enumResource(EXPRESSION_RUNTIME_ENUM_CONTINUOUS);
		this.labelExpressionOneTime = loc.enumResource(EXPRESSION_RUNTIME_ENUM_ONETIME);
		this.labelInitialValue = loc.resource("AttributeDefinitionInitialValue");
		this.labelRESTNone = loc.resource("AttributeDefinitionRESTAccessNone");
		this.labelRESTRead = loc.resource("AttributeDefinitionRESTAccessRead");
		this.labelRESTWrite = loc.resource("AttributeDefinitionRESTAccessWrite");
		this.labelRequired = loc.resource("AttributeDefinitionRequired");
		this.labelUOM = loc.type("UnitOfMeasure"); // "Unit of Measure"
		this.labelUOMType = loc.type("UOMType");
	}
}